import { FC } from 'react'
import { Table } from '../../components/Table'
import { createColumnHelper } from '@tanstack/react-table'
import styles from './styles.module.css'
interface TokenTableProps {
  data?: any[]
}

export const UserTable: FC<TokenTableProps> = (props: TokenTableProps) => {
  const { data = [] } = props

  const columnHelper = createColumnHelper<any>()
  const tableColumns = [
    columnHelper.accessor('nickname', {
      header: 'Account',
      cell: (value) => {
        return value.getValue()
      }
    }),
    columnHelper.accessor('followers', {
      header: 'Followers',
      size: 200,
      cell: (value) => {
        return value.getValue()
      }
    })
  ]

  return (
    <Table
      data={data}
      columns={tableColumns}
      justify="center"
      rowClassName={styles.row}
      wrapperClassName={styles.tableWrapper}
    />
  )
}
